<template>
  <!--screenshots section-->
  <section class="team-bg" id="team" ref="teamPosition">
    <div class="animation-circle-inverse"><i></i><i></i><i></i></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-title">
            <h2>Our Work Place</h2>
            <div class="line"></div>
          </div>
        </div>
        <div class="col-md-12">
          <swiper
            :modules="modules"
            :slides-per-view="3"
            :space-between="20"
            :breakpoints="{
              '0': {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              '580': {
                slidesPerView: 2,
                spaceBetween: 15,
              },

              '1000': {
                slidesPerView: 3,
                spaceBetween: 15,
              },
            }"
          >
            <swiper-slide v-for="image in images" :key="image.id">
              <div class="item">
                <transition name="fade-carousel">
                  <div class="team-box" v-if="showCarousel">
                    <!-- :style="{ display: showCarousel ? '' : 'none' }" -->
                    <div class="team-under-box">
                      <div
                        class="team-under-box-button text-white"
                        @click="toggleCardDetails"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </div>
                      <img class="img-fluid" :src="image.imageUrl" alt="1" />
                      <div class="team-overlay">
                        <div class="social-icon">
                          <ul>
                            <li>
                              <a href="#"
                                ><i
                                  class="fa fa-facebook"
                                  aria-hidden="true"
                                ></i
                              ></a>
                            </li>
                            <li>
                              <a href="#"
                                ><i
                                  class="fa fa-google-plus"
                                  aria-hidden="true"
                                ></i
                              ></a>
                            </li>
                            <li>
                              <a href="#"
                                ><i class="fa fa-twitter" aria-hidden="true"></i
                              ></a>
                            </li>
                            <li>
                              <a href="#"
                                ><i
                                  class="fa fa-instagram"
                                  aria-hidden="true"
                                ></i
                              ></a>
                            </li>
                            <li>
                              <a href="#"
                                ><i class="fa fa-rss" aria-hidden="true"></i
                              ></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="col-md-12">
          <transition name="fade-details">
            <div class="team-hover" v-if="!showCarousel">
              <!-- :style="{ display: showCarousel ? 'none' : '' }" -->
              <div class="row">
                <div class="col-md-4">
                  <div class="team-profile">
                    <img
                      class="img-fluid"
                      src="../assets/images/1.jpg"
                      alt="1"
                    />
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="d-flex-1">
                    <div class="hover-text">
                      <div class="team-close-btn" @click="toggleCardDetails">
                        <a><i class="fa fa-times" aria-hidden="true"></i></a>
                      </div>
                      <h3>Mark Jecno</h3>
                      <h4 class="m-0 text-muted">Devloper & Designer</h4>
                      <h5>PHP, Laravel, Cake , Wordpress, HTML5</h5>
                      <p>
                        It is a long established fact that a reader will be
                        distracted by the readable content of a page when
                        looking at its layout. The point of using Lorem Ipsum is
                        that it has a more-or-less normal distribution of
                        letters, as opposed to using 'Content here, content
                        here', making it look like readable English. Many
                        desktop publishing packages and web page editors now use
                        Lorem Ipsum as their default model text,
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
  <!--end screenshots section-->
</template>

<script>
import SwiperCore, {
  Navigation,
  Parallax,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
SwiperCore.use(Navigation);

export default {
  name: "Screenshots",
  components: {
    Swiper,
    SwiperSlide,
    // swiperSlide,
    // swiper,
    // VueSlickCarousel,
  },
  data() {
    return {
      showCarousel: true,
      modules: [Navigation, Pagination, Scrollbar, A11y],
      images: [
        {
          id: 1,
          imageUrl: require("../assets/images/1.jpg"),
        },
        {
          id: 2,
          imageUrl: require("../assets/images/2.jpg"),
        },
        {
          id: 3,
          imageUrl: require("../assets/images/3.jpg"),
        },
        {
          id: 4,
          imageUrl: require("../assets/images/4.jpg"),
        },
        {
          id: 5,
          imageUrl: require("../assets/images/2.jpg"),
        },
        {
          id: 6,
          imageUrl: require("../assets/images/2.jpg"),
        },
      ],
      parallaxSwiperWidth: 0,
    };
  },
  mounted() {
    let payload = {
      position: this.$refs["teamPosition"].offsetTop,
      name: "teamPosition",
    };
    this.$emit("windowPosition", payload);
  },
  methods: {
    toggleCardDetails() {
      this.showCarousel = !this.showCarousel;
    },
  },
};
</script>
<style scoped>
.fade-carousel-enter-active,
.fade-details-enter-active,
.fade-carousel-leave-active,
.fade-details-leave-active {
  transition: all 0.5s ease;
}

.fade-carousel-enter-from,
.fade-details-enter-from,
.fade-carousel-leave-to,
.fade-details-leave-to {
  height: 0;
  width: 0;
  /* opacity: 0; */
}
.fade-carousel-enter-to,
.fade-details-enter-to {
  height: 100%;
  width: 100%;
  /* opacity: 0; */
}
</style>
